import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;

  header {
    display: flex;
    flex-direction: column;
    gap: 16px;

    h1 {
      font-size: 24px;
      font-weight: 600;
      color: #263238;
    }

    p {
      color: #757575;
      font-size: 16px;
      font-weight: 300;
    }
  }
`;

export const CustomForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  & > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 16px;
    justify-content: center;

    & > div:first-child {
      max-width: 400px;
      min-width: 250px;
    }
  }

  & > button {
    width: 100%;
    max-width: 400px;
  }
`;
